<div class="white-box main-black mt-4 p-4 border-radius">
	<app-power-study-header-report [device]="device" [studyInfo]="studyInfo" [siteInfo]="siteInfo" [selectedPeriodFormatted]="selectedPeriodFormatted"></app-power-study-header-report>
	<div class="white-box main-black p-2 border-radius">
		<h3 class="h4 mb-4">{{'utilization.study_utilization_metrics' | translate}}</h3>
		<app-truck-summary-report-performance [data]="data" [selectedDays]="selectedDays" [totalTrucks]="1"></app-truck-summary-report-performance>	
	</div>
	<div class="white-box main-black p-2 border-radius mb-4">
		<h3 class="h4 mb-4">{{'utilization.daily_usage_metrics' | translate}}</h3>
		<app-daily-usage-metrics [data]="data" [selectedDays]="selectedDays"></app-daily-usage-metrics>	
	</div>

	<div class="white-box main-black p-2 border-radius mt-4">
		<app-daily-usage-charts [data]="data" [selectedDays]="selectedDays" [onPrint]="onPrint"></app-daily-usage-charts>	
	</div>
</div>
